module.exports = "<div id=\"wrapper\">\n  <div class=\"overlay\"></div>\n  <div id=\"webview\"></div>\n  <app-navbar></app-navbar>\n  <app-sidebar></app-sidebar>\n  <div id=\"page-content-wrapper\" class=\"col-xs-12 {{loading}} {{printPage}}\">\n    <app-alert></app-alert>\n    <router-outlet></router-outlet>\n  </div>\n  <footer class=\" footer text-center active col-xs-12\">\n    2021 &copy; Vistaura | Vistanova Solutions Pvt. Ltd.\n  </footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// /root/production/sne-pro/src/app/layout/app-layout/app-layout.component.html
// module id = ../../../../../src/app/layout/app-layout/app-layout.component.html
// module chunks = main